export default __webpack_public_path__ + "static/media/feature3.0ceb9b32.svg";